(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _historyController = _interopRequireDefault(require("impv/src/js/modules/history-controller"));

var _xhrFilterBlog = _interopRequireDefault(require("impv/src/js/components/xhr-filter-blog"));

var _loadMore = _interopRequireDefault(require("impv/src/js/components/load-more"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

jQuery(function () {
  // initStickyScrollBlock();
  initHistoryController();
  initXhrFiltering();
  initLoadMore(); // initPositionDetector();

  initMobileFilters();
});

function initLoadMore() {
  _toConsumableArray(document.querySelectorAll('[id="listing"]')).forEach(function (holder) {
    new _loadMore["default"](holder);
  });
} // init filtering


function initXhrFiltering() {
  var docEl = document.documentElement;
  var onceFilteredClass = 'filters-applied';

  _toConsumableArray(document.querySelectorAll('[id="listing"]')).forEach(function (holder) {
    new _xhrFilterBlog["default"](holder, {
      onSuccess: function onSuccess() {
        if (!docEl.classList.contains(onceFilteredClass)) {
          docEl.classList.add(onceFilteredClass);
        }
      }
    });
  });
} // changes page's url on scroll without reload


function initHistoryController() {
  new _historyController["default"]({
    elementsSelector: '.outer-card',
    dataKey: 'url'
  });
}

function initPositionDetector() {
  _toConsumableArray(document.querySelectorAll('body')).forEach(function (element) {
    new PositionDetectorAdvanced(element, {
      stickyElementSelector: '.highlight-section',
      startScrollElementSelector: '.row-main',
      stopScrollElementSelector: '.row-main',
      stickyClass: 'fixed',
      bottomClass: 'at-bottom'
    });
  });
} // Mobile filters


function initMobileFilters() {
  var $dropTable = $('.drop-table');
  $dropTable.on('show.bs.collapse', function (e) {
    var elemId = $(e.currentTarget).attr('id').toString();
    $('a[data-target="#' + elemId + '"]').siblings('.impv-icon').addClass('collapse-icon').removeClass('expand-icon');
  });
  $dropTable.on('hide.bs.collapse', function (e) {
    var elemId = $(e.currentTarget).attr('id').toString();
    $('a[data-target="#' + elemId + '"]').siblings('.impv-icon').addClass('expand-icon').removeClass('collapse-icon');
  });
  $('a.filter-btns').on('click', function () {
    $('#featuredAssetList').addClass('filters-applied');
    $('.page-indicator').css('visibility', 'hidden'); // $('.filter-opener').trigger('click');
  });
}

},{"impv/src/js/components/load-more":2,"impv/src/js/components/xhr-filter-blog":3,"impv/src/js/modules/history-controller":4}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var LoadMore =
/*#__PURE__*/
function () {
  function LoadMore(holder) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, LoadMore);

    this.options = Object.assign({
      filters: '.filter-button, .filter-btns',
      loadBtn: '.more-holder .impv-blue-btn',
      pagingHolder: '.pagination',
      filtersBar: '.filters-bar',
      cardsHolder: '.card-library .tile-list',
      cards: '.outer-card',
      loadMoreBtnHolder: '.more-holder',
      loadMoreBtn: 'a',
      selectedClass: 'chosen',
      loadingClass: 'load-more-is-loading',
      errorClass: 'error',
      hiddenClass: 'd-none',
      method: 'GET',
      // static part of API's URL
      apiUrlAttr: 'data-api-loadmore-url',
      // fetch success
      onSuccess: function onSuccess() {},
      // for modifying loaded dom elements before inserting
      wrapperFn: function wrapperFn(x) {
        return x;
      }
    }, opts);

    if (holder) {
      this.holder = holder;
      this.init();
    }
  }

  _createClass(LoadMore, [{
    key: "init",
    value: function init() {
      this.prevControllers = null;
      this.attachEvents(); // load first hidden items

      this.sendRequest();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;

      this.onHolderClick = function (e) {
        var target = e.target;

        var loadBtn = _this.getLoadBtn();

        if (loadBtn) {
          var loadBtnIsParent = target.closest(_this.options.loadBtn);

          if (loadBtnIsParent || target === loadBtn) {
            e.preventDefault();

            _this.loadMore();
          }
        }
      };

      this.onFilterSuccess = function (e) {
        // send requst after filtering
        _this.sendRequest();
      };

      this.holder.addEventListener('click', this.onHolderClick); // 'on_filter_success' event fires in ./xhr-filter.js

      document.addEventListener('on_filter_success', this.onFilterSuccess);
    }
  }, {
    key: "loadMore",
    value: function loadMore() {
      // show previous loaded items
      this.showPreviousItems(); // show previous controllers

      this.showPrevControllers(); // load new items

      this.sendRequest();
    }
  }, {
    key: "sendRequest",
    value: function sendRequest() {
      if (this.isLoading) return;
      this.holder.classList.add(this.options.loadingClass);
      var url = this.buildUrl();
      this.makeRequest(url);
    }
  }, {
    key: "makeRequest",
    value: function makeRequest(url) {
      var _this2 = this;

      this.isLoading = true;
      fetch(url, {
        method: this.options.method || 'GET'
      }).then(function (r) {
        return r.text();
      }).then(function (newContent) {
        _this2.isLoading = false;

        _this2.changeContent(newContent);

        _this2.updatePageNumber();

        _this2.holder.classList.remove(_this2.options.loadingClass);

        _this2.options.onSuccess();
      })["catch"](function (err) {
        _this2.isLoading = false;

        _this2.holder.classList.remove(_this2.options.loadingClass);

        _this2.holder.classList.add(_this2.options.errorClass);

        console.log(err);
      });
    }
  }, {
    key: "updatePageNumber",
    value: function updatePageNumber() {
      var dataBlock = this.getCounterBlock();
      var pageNumber = dataBlock.getAttribute('data-page-number');
      pageNumber = parseInt(pageNumber, 10);
      pageNumber = pageNumber + 1;
      dataBlock.setAttribute('data-page-number', pageNumber);
    }
  }, {
    key: "changeContent",
    value: function changeContent(newContent) {
      if (newContent) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(newContent, 'text/html');

        if (doc) {
          // wrapperFn - changes dom elemets before inserting
          this.options.wrapperFn(doc); // save new controllers to insert next time

          this.updateControllers(doc); // append new items

          var list = this.holder.querySelector(this.options.cardsHolder);
          var newCards = doc.querySelectorAll(this.options.cards);
          this.appendCards(newCards, list);
        }
      }
    }
  }, {
    key: "appendCards",
    value: function appendCards(newCards, list) {
      if (list && newCards.length) {
        // add hidden class before inserting
        this.switchItemsVisibility(newCards, 'add'); // insert new items

        this.appendNodeListToEl(list, newCards);
      }
    }
  }, {
    key: "appendNodeListToEl",
    value: function appendNodeListToEl(target, nodeList) {
      var frag = document.createDocumentFragment();

      _toConsumableArray(nodeList).forEach(function (card) {
        frag.appendChild(card);
      });

      target.appendChild(frag);
    }
  }, {
    key: "switchItemsVisibility",
    value: function switchItemsVisibility(items) {
      var _this3 = this;

      var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'add';

      _toConsumableArray(items).forEach(function (item) {
        var fn = item.classList[method];

        if (typeof fn === 'function') {
          item.classList[method](_this3.options.hiddenClass);
        }
      });
    }
  }, {
    key: "showPreviousItems",
    value: function showPreviousItems() {
      var _this4 = this;

      var cards = _toConsumableArray(this.holder.querySelectorAll(this.options.cards)).filter(function (card) {
        return card.classList.contains(_this4.options.hiddenClass);
      });

      this.switchItemsVisibility(cards, 'remove');
    }
  }, {
    key: "showPrevControllers",
    value: function showPrevControllers() {
      var _this5 = this;

      if (!this.prevControllers) return;
      this.prevControllers.forEach(function (d) {
        var selector = d.selector,
            newEl = d.newEl;

        var el = _this5.holder.querySelector(selector);

        _this5.updateEl(el, newEl);
      });
    }
  }, {
    key: "updateEl",
    value: function updateEl(oldEl, newEl) {
      if (oldEl && newEl) {
        oldEl.parentNode.replaceChild(newEl, oldEl);
      }

      if (!newEl) {
        oldEl.classList.add('d-none');
      }
    }
  }, {
    key: "buildUrl",
    value: function buildUrl() {
      // builds url for fetch filtered items
      var siteUrl = window.pageGlobalData.siteUrl;
      var baseAPIURL = siteUrl;
      var dataBlock = this.getCounterBlock();
      var params = this.getSerialize();
      var url = baseAPIURL;

      if (dataBlock) {
        var urlPart = dataBlock.getAttribute(this.options.apiUrlAttr);
        var pageId = dataBlock.getAttribute('data-page-id');
        var enabledPagination = dataBlock.getAttribute('data-enable-pagination');
        var pageNumber = dataBlock.getAttribute('data-page-number');
        url = "".concat(baseAPIURL).concat(urlPart).concat(pageNumber, "/filters/").concat(params, "/").concat(pageId, "/").concat(enabledPagination);
      }

      return url;
    }
  }, {
    key: "getLoadBtn",
    value: function getLoadBtn() {
      return this.holder.querySelector(this.options.loadBtn);
    }
  }, {
    key: "getSerialize",
    value: function getSerialize() {
      var _this6 = this;

      // returns string in format 'name=value&name=value' or ''
      var result = '';
      var filters = this.getFilters();

      var strTemp = function strTemp(name, value) {
        return "".concat(name, "=").concat(value, "&");
      };

      _toConsumableArray(filters).forEach(function (filter) {
        if (filter.tagName.toUpperCase() === 'LABEL') {
          // get params if filter is label tag
          var input = _this6.getInput(filter);

          if (input && input.checked) {
            result += strTemp(input.name, input.value);
          }
        } else {
          if (filter.classList.contains(_this6.options.selectedClass)) {
            var name = filter.getAttribute('data-name');
            var value = filter.getAttribute('data-value');
            var record = strTemp(name, value); // avoid duplicating params if html contains equal filters for responsive purpose

            if (result.indexOf(record) === -1) {
              result += record;
            }
          }
        }
      }); // replace last &


      return result.slice(0, -1);
    }
  }, {
    key: "updateControllers",
    value: function updateControllers(source) {
      var selectors = [this.options.pagingHolder, this.options.loadMoreBtnHolder];
      this.prevControllers = selectors.map(function (selector) {
        return {
          selector: selector,
          newEl: source.querySelector(selector)
        };
      });
    }
  }, {
    key: "getCounterBlock",
    value: function getCounterBlock() {
      return document.querySelector('#page-counter-block');
    }
  }, {
    key: "getFilters",
    value: function getFilters() {
      return this.holder.querySelectorAll(this.options.filters);
    }
  }, {
    key: "getInput",
    value: function getInput(label) {
      return label.querySelector('input[type="radio"], input[type="checkbox"]');
    }
  }]);

  return LoadMore;
}();

var _default = LoadMore;
exports["default"] = _default;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var XhrFilter =
/*#__PURE__*/
function () {
  function XhrFilter(holder) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, XhrFilter);

    this.options = Object.assign({
      drop: '.impv-dropdown',
      filtersHolder: '.filter-btn-div',
      filters: '.filter-button, .filter-btns',
      filterIsLink: 'a.filter-btns',
      filtersBar: '.filters-bar',
      filtersDisplay: '.filter-opener',
      selectedFilter: false,
      cardsHolder: '.tile-list',
      cards: '.outer-card',
      pagingHolder: '.pagination',
      paging: '.nav-links',
      loadMoreBtnHolder: '.more-holder',
      loadMoreBtn: 'a',
      selectedClass: 'chosen',
      loadingClass: 'is-loading',
      errorClass: 'error',
      method: 'GET',
      // static part of API's URL
      apiUrlAttr: 'data-api-filtration-url',
      // fetch success
      onSuccess: function onSuccess() {},
      onBeforeSend: function onBeforeSend() {},
      // for modifying loaded dom elements before inserting
      wrapperFn: function wrapperFn(x) {
        return x;
      }
    }, opts);

    if (holder) {
      this.holder = holder;
      this.init();
    }
  }

  _createClass(XhrFilter, [{
    key: "init",
    value: function init() {
      this.onLoadEvt = new Event('on_filter_success');
      this.activeParams = '';
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;

      this.filteringTimerId = null;

      this.onHolderClick = function (e) {
        var target = e.target;

        var filters = _this.getFilters();

        var links = _this.getFilterLinks();

        var targetRelatedToFilter = target.closest(_this.options.filters) || _toConsumableArray(filters).indexOf(target) > -1;
        var linkTarget = target.closest(_this.options.filterIsLink);
        var targetIsLink = linkTarget || _toConsumableArray(links).indexOf(target) > -1; // handle toggling selected class on filters that have tagName = 'a'

        if (targetIsLink) {
          var activeLink = linkTarget ? linkTarget : target;

          var groupLinks = _this.getGroupLinks(activeLink); // add class to selected link and remove from others


          _this.toggleSelectedClass(groupLinks, activeLink);
        } // target is filter controller


        if (targetRelatedToFilter) {
          clearTimeout(_this.filteringTimerId);
          _this.filteringTimerId = setTimeout(function () {
            // run filtering after other handlers was executeded
            _this.runFiltering();
          }, 100);
        } // Set filter selection


        if (target.className == 'text' && target.textContent) {
          _this.options.selectedFilter = target.textContent;
        }
      };

      this.holder.addEventListener('click', this.onHolderClick);
    }
  }, {
    key: "runFiltering",
    value: function runFiltering() {
      var params = this.getSerialize();
      this.activeParams = params;
      var url = this.buildUrl(params);
      this.holder.classList.remove(this.options.errorClass);
      this.holder.classList.add(this.options.loadingClass);
      this.makeRequest(url);
    }
  }, {
    key: "makeRequest",
    value: function makeRequest(url) {
      var _this2 = this;

      this.options.onBeforeSend();
      fetch(url, {
        method: this.options.method || 'GET'
      }).then(function (r) {
        return r.text();
      }).then(function (newContent) {
        _this2.changeContent(newContent);

        _this2.changePageUrl();

        _this2.holder.classList.remove(_this2.options.loadingClass);

        _this2.options.onSuccess();

        document.dispatchEvent(_this2.onLoadEvt); // for mobile only: update filter field and collapse accordion

        var filterDisplayField = _this2.options.filtersDisplay,
            selectedFilter = _this2.options.selectedFilter;

        if (selectedFilter) {
          var df = document.querySelector(filterDisplayField);
          df.innerText = selectedFilter;
          df.click();
        }
      })["catch"](function (err) {
        _this2.holder.classList.remove(_this2.options.loadingClass);

        _this2.holder.classList.add(_this2.options.errorClass);

        console.log(err);
      });
    }
  }, {
    key: "toggleSelectedClass",
    value: function toggleSelectedClass(links, activeLink) {
      var _this3 = this;

      _toConsumableArray(links).forEach(function (link) {
        var name = link.getAttribute('data-name');
        var val = link.getAttribute('data-value');
        var activeName = activeLink.getAttribute('data-name');
        var activeVal = activeLink.getAttribute('data-value');

        if (name === activeName && val === activeVal) {
          link.classList.add(_this3.options.selectedClass);
        } else {
          link.classList.remove(_this3.options.selectedClass);
        }
      });
    }
  }, {
    key: "changePageUrl",
    value: function changePageUrl() {
      var cards = this.holder.querySelectorAll(this.options.cards);

      if (cards.length) {
        var firstCard = cards[0];
        var newUrl = firstCard.getAttribute('data-url');

        if (newUrl) {
          history.replaceState(null, null, newUrl);
        }
      }
    }
  }, {
    key: "changeContent",
    value: function changeContent(newContent) {
      if (newContent) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(newContent, 'text/html');

        if (doc) {
          // wrapperFn - changes dom elemets before inserting
          this.options.wrapperFn(doc); // elemets for replace/delete with new content

          var selectors = [this.options.cardsHolder]; // replace or delete elements that should be updated

          this.updateControllers(doc);
          this.replaceElementsBySelector(selectors, this.holder, doc); // filter's html come from server without active state
          // toggle active state on incoming filters according to choice

          this.toggleActiveStateOnFilter();
        }
      }
    }
  }, {
    key: "getSerialize",
    value: function getSerialize() {
      var _this4 = this;

      // returns string in format 'name=value&name=value' or ''
      var result = '';
      var filters = this.getFilters();

      var strTemp = function strTemp(name, value) {
        return "".concat(name, "=").concat(value, "&");
      };

      _toConsumableArray(filters).forEach(function (filter) {
        if (filter.tagName.toUpperCase() === 'LABEL') {
          // get params if filter is label tag
          var input = _this4.getInput(filter);

          if (input && input.checked) {
            result += strTemp(input.name, input.value);
          }
        } else {
          if (filter.classList.contains(_this4.options.selectedClass)) {
            var name = filter.getAttribute('data-name');
            var value = filter.getAttribute('data-value');
            var record = strTemp(name, value); // avoid duplicating params if html contains equal filters for responsive purpose

            if (result.indexOf(record) === -1) {
              result += record;
            }
          }
        }
      }); // replace last &


      return result.slice(0, -1);
    }
  }, {
    key: "buildUrl",
    value: function buildUrl(filtersSerialize) {
      // builds url for fetch filtered items
      var siteUrl = window.pageGlobalData.siteUrl;
      var baseAPIURL = siteUrl;
      var dataBlock = document.querySelector('#page-counter-block');
      var url = baseAPIURL;

      if (dataBlock) {
        var urlPart = dataBlock.getAttribute(this.options.apiUrlAttr);
        var pageId = dataBlock.getAttribute('data-page-id');
        var enabledPagination = dataBlock.getAttribute('data-enable-pagination'); // For Archive Blogs

        var listing_el = document.getElementById("listing");
        var archive_id = listing_el.getAttribute("data-archive-id");
        var archive_flag = listing_el.getAttribute("data-archive-flag");
        dataBlock.setAttribute('data-page-number', 2);
        /* Note: this is also used in company/news and learning center */

        url = "".concat(baseAPIURL).concat(urlPart, "/1/filters/").concat(filtersSerialize, "/").concat(pageId, "/").concat(enabledPagination);
        if (archive_id) url += archive_flag === 'true' ? "/archive/".concat(archive_id) : '/archive/0';
      }

      return url;
    }
  }, {
    key: "toggleActiveStateOnFilter",
    value: function toggleActiveStateOnFilter() {
      var _this5 = this;

      if (this.activeParams.length) {
        var paramsList = this.activeParams.split('&');
        paramsList.forEach(function (param) {
          var index = param.indexOf('=');

          if (index > -1) {
            var name = param.slice(0, index);
            var value = param.slice(index + 1);

            _toConsumableArray(_this5.getFiltersByName(name)).forEach(function (filter) {
              if (filter.tagName === 'INPUT') {
                // handle inputs
                var val = filter.getAttribute('value');

                if (val === value) {
                  filter.setAttribute('checked', true);
                } else {
                  filter.removeAttribute('checked');
                }
              } else {
                // handle links
                var _val = filter.getAttribute('data-value');

                if (_val === value) {
                  filter.classList.add(_this5.options.selectedClass);

                  _this5.updateOpener(filter);
                } else {
                  filter.classList.remove(_this5.options.selectedClass);
                }
              }
            });
          }
        });
      }
    }
  }, {
    key: "updateControllers",
    value: function updateControllers(source) {
      var _this6 = this;

      var selectors = [{
        parent: this.options.pagingHolder,
        child: this.options.paging
      }, {
        parent: this.options.loadMoreBtnHolder,
        child: this.options.loadMoreBtn
      }];
      selectors.forEach(function (d) {
        var parent = d.parent,
            child = d.child;

        var parentEl = _this6.holder.querySelector(parent);

        var oldEl = _this6.holder.querySelector("".concat(parent, " ").concat(child));

        var newEL = source.querySelector("".concat(parent, " ").concat(child));

        if (parentEl) {
          if (oldEl) {
            oldEl.remove();
          }

          if (newEL) {
            parentEl.appendChild(newEL);
          }
        }
      });
    }
  }, {
    key: "updateOpener",
    value: function updateOpener(filter) {
      var text = filter.innerText;
      var drop = filter.closest(this.options.drop);

      if (drop) {
        var button = drop.querySelector('.dropdown-btn .name');

        if (button) {
          button.innerText = text;
        }
      }
    }
  }, {
    key: "replaceElementsBySelector",
    value: function replaceElementsBySelector() {
      var selectors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var holder = arguments.length > 1 ? arguments[1] : undefined;
      var incomingHolder = arguments.length > 2 ? arguments[2] : undefined;
      selectors.forEach(function (selector) {
        var oldEls = _toConsumableArray(holder.querySelectorAll(selector));

        var newElems = _toConsumableArray(incomingHolder.querySelectorAll(selector));

        oldEls.forEach(function (el, i) {
          var newEl = newElems[i];

          if (newEl) {
            el.parentNode.replaceChild(newEl, el);
          } else {
            el.remove();
          }
        });
      });
    }
  }, {
    key: "getInput",
    value: function getInput(label) {
      return label.querySelector('input[type="radio"], input[type="checkbox"]');
    }
  }, {
    key: "getFilterLinks",
    value: function getFilterLinks() {
      return this.holder.querySelectorAll(this.options.filterIsLink);
    }
  }, {
    key: "getGroupLinks",
    value: function getGroupLinks(link) {
      var name = link.getAttribute('data-name');
      var links = this.holder.querySelectorAll("".concat(this.options.filtersHolder, " a[data-name=\"").concat(name, "\"]"));
      return links;
    }
  }, {
    key: "getFiltersByName",
    value: function getFiltersByName(name) {
      return this.holder.querySelectorAll("input[name=\"".concat(name, "\"], [data-name=\"").concat(name, "\"]"));
    }
  }, {
    key: "getFilters",
    value: function getFilters() {
      return this.holder.querySelectorAll(this.options.filters);
    }
  }]);

  return XhrFilter;
}();

var _default = XhrFilter;
exports["default"] = _default;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HistoryController =
/*#__PURE__*/
function () {
  function HistoryController() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, HistoryController);

    _defineProperty(this, "scrollEl", document.scrollingElement || document.documentElement);

    this.options = Object.assign({
      elementsSelector: '',
      dataKey: ''
    }, opts);
    this.init();
  }

  _createClass(HistoryController, [{
    key: "init",
    value: function init() {
      this.url = location.href;
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;

      this.scrollFn = function () {
        _this.checkItems();
      };

      window.addEventListener('scroll', this.scrollFn);
    }
  }, {
    key: "setPageUrl",
    value: function setPageUrl() {
      history.replaceState(null, null, this.url);
    }
  }, {
    key: "checkItems",
    value: function checkItems() {
      var _this2 = this;

      _toConsumableArray(document.querySelectorAll(this.options.elementsSelector)).forEach(function (el) {
        var st = _this2.scrollEl.scrollTop;
        var elBox = el.getBoundingClientRect();
        var blockTop = elBox.top + st;
        var from = blockTop > st + elBox.height;
        var to = blockTop < st + elBox.height * 2;

        if (from && to) {
          if (!el.isActiveUrl) {
            var elUrl = el.dataset[_this2.options.dataKey];

            if (elUrl !== _this2.url) {
              el.isActiveUrl = true;
              _this2.url = elUrl;

              _this2.setPageUrl();
            }
          }
        } else {
          if (el.isActiveUrl) {
            el.isActiveUrl = false;
          }
        }
      });
    }
  }]);

  return HistoryController;
}();

exports["default"] = HistoryController;

},{}]},{},[1]);
